export default () => ({
    url: process.env.REACT_APP_API_ENDPOINT || "https://devapi.tryotel.com/graphql",
    subscriptionUrl: process.env.REACT_APP_SUBSCRIPTION_ENDPOINT || "wss://devapi.tryotel.com/graphql",
    uploadUrl: process.env.REACT_APP_UPLOAD_API_ENDPOINT || "https://devupload.tryotel.com/upload",
    publicUploadUrl: process.env.REACT_APP_UPLOAD_PUBLIC_API_ENDPOINT || "https://devupload.tryotel.com/public-upload",
    downloadUrl: process.env.REACT_APP_BASE_DOWNLOAD || "https://b2c-download.flightlocal.com"
})